import React, { useEffect, useState } from "react";
import { trackPromise } from "react-promise-tracker";

import InfiniteScroll from "react-infinite-scroll-component";
import { Dropdown, List, Menu } from "antd";
import services from "../../../../services";
import imgBanner from "../../../../assets/iconsMenu/img.svg";
import "./styles.scss";

const ListBanner = ({ banners, showBanner }) => {
  const { IdUser, login, IsAdmin } = services.storage.getUser();
  const [bannerSelecionado, setBannerSelecionado] = useState("");

  return (
    <div>
      <List
        className="list-permissoes mt-4"
        size="small"
        header={<span className="list-header">BANNERS CADASTRADOS</span>}
        dataSource={banners}
        renderItem={(item) => {
          return (
            <List.Item
              className="list-item listaNotificacao"
              style={{ cursor: "pointer" }}
              onClick={() => {
                showBanner(item.id);
                setBannerSelecionado(item.id);
              }}
            >
              <div>
                <span
                  onClick={() => {
                    showBanner(item.id);
                  }}
                >
                  <img width={30} src={imgBanner} className="mr-4" />
                  {item.titulo}
                </span>
              </div>
            </List.Item>
          );
        }}
      />
    </div>
  );
};

export default ListBanner;
